import { Image, ImageProps } from '@chakra-ui/react'
import svg from 'assets/artwork/computers.svg'
import { forwardRef } from 'react'

export const Computers = forwardRef<HTMLImageElement, ImageProps>((props, ref) => {
    return <Image {...props} src={svg} alt="a group of different computers" ref={ref} />
})
